<template>
<div id="notification-nouveau">

    <vs-popup class="holamundo" title="Nouveau modèle de notification" :active.sync="popupActiv">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Désignation</label>
                    <div class="mt-2">
                        <vs-input class="w-full" :disabled="popupDisabled" icon-pack="feather" v-model="modeleNotification.designation" icon="icon-info" />
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Description</label>
                    <div class="mt-2">
                        <vs-textarea :disabled="popupDisabled" v-model="modeleNotification.description" :counter-danger.sync="counterDanger" height="50px" counter="200" class="w-full" />
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Titre</label>
                    <div class="mt-2">
                        <vs-input :disabled="popupDisabled" class="w-full" icon-pack="feather" v-model="modeleNotification.title" icon="icon-info" />
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Message</label>
                    <div class="mt-2">
                        <vs-input :disabled="popupDisabled" class="w-full" icon-pack="feather" v-model="modeleNotification.msg" icon="icon-info" />
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Couleur</label>
                    <div class="mt-4">
                        <input :disabled="popupDisabled" type="color" class="w-full" v-model="color">
                    </div>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <div class="w-full mt-4">
                    <label class="mt-2">Icone (feathericons.com)</label>
                    <div class="mt-2">
                        <vs-input :disabled="popupDisabled" class="w-full" icon-pack="feather" v-model="modeleNotification.icon" icon="icon-info" placeholder="Excemple : InfoIcon" />
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button color="primary" type="gradient" @click="enregistrer" :disabled="DisableEnregistrer">Enregistrer</vs-button>
                </div>
            </div>
        </div>

    </vs-popup>

    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class> Modèles notifications </h4>
            </div>
        </div>
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-table ref="table" pagination :max-items="itemsPerPageModele" search :data="dataListModele" v-model="selectedModele">

                            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-file-plus" @click="OpenModal('créer')">Nouveau modèle</vs-button>
                            </div>
                            <template slot="thead">
                                <vs-th sort-key="designation" class="table_head_color">Désignation</vs-th>
                                <vs-th sort-key="title" class="table_head_color">Titre</vs-th>
                                <vs-th sort-key="msg" class="table_head_color">Message</vs-th>
                                <vs-th sort-key="icon" class="table_head_color">Icone</vs-th>
                                <vs-th sort-key="color" class="table_head_color">Couleur</vs-th>
                                <vs-th sort-key="cretedAt" class="table_head_color">Crée le</vs-th>
                                <vs-th class="table_head_color">Action</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                        <vs-td>
                                            <p>{{ tr.designation }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.title }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.msg }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.icon }}</p>
                                        </vs-td>

                                        <vs-td :style="`background-color:${tr.color}`">
                                            <p style="color:#ffffff">{{tr.color}}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.createdAt }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <feather-icon icon="InfoIcon" color="warning" svgClasses="w-5 h-5 hover:text-warning stroke-current" @click="OpenModal('consulter',tr)" />
                                            <feather-icon icon="EditIcon" color="success" svgClasses="w-5 h-5 hover:text-success stroke-current" @click="OpenModal('modifier',tr)" class="ml-2" />
                                            <feather-icon icon="Trash2Icon" color="danger" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click="checkDeletModele(tr.id)" class="ml-2" />
                                        </vs-td>

                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>

    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class> Liste des client </h4>
            </div>
        </div>
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-table ref="table" pagination :max-items="itemsPerPageClient" search :data="dataListClient" multiple v-model="selectedsClient">

                            <template slot="thead">
                                <vs-th sort-key="Item_No" class="table_head_color">Code</vs-th>
                                <vs-th sort-key="Name" class="table_head_color">Nom</vs-th>
                                <vs-th sort-key="Year" class="table_head_color">Téléphone</vs-th>
                                <vs-th sort-key="Year" class="table_head_color">Email</vs-th>
                                <vs-th sort-key="Year" class="table_head_color">Magasin</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                        <vs-td>
                                            <p>{{ tr.No }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.Name }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.Phone_No }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.E_Mail }}</p>
                                        </vs-td>

                                        <vs-td>
                                            <p>{{ tr.Location_Code }}</p>
                                        </vs-td>

                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end">
                            <vs-button class="ml-auto mt-2" :disabled="DisableConfirmer" @click="notifier">Envoyer notification</vs-button>

                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Initialiser</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import notificationService from "@/http/requests/notification/index.js";
import vSelect from "vue-select";

export default {
    components: {
        "v-select": vSelect
    },
    data() {
        return {
            itemsPerPageModele: 5,
            dataListModele: [],
            selectedModele: {},
            itemsPerPageClient: 8,
            dataListClient: [],
            selectedsClient: [],
            popupActiv: false,
            counterDanger: false,
            check: null,
            modeleNotification: {
                designation: "",
                description: "",
                title: "",
                msg: "",
                icon: "",
            },
            color: "#28C76F",
            popupDisabled: false,
            id: 0
        }
    },
    watch: {
        dataListModele: function () {
            this.$vs.loading.close();
            this.$vs.loading.close("#notification-nouveau > .con-vs-loading");
        }
    },
    methods: {
        checkDeletModele(id) {
            this.id = id;
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Suppression du modèle`,
                text: "etes vous sur de vouloir supprimer cet modèle ? tous les notifications de ce modèle seront supprimés définitivement !",
                acceptText: "Supprimer",
                cancelText: "Annuler",
                accept: this.deleteModele
            });
        },
        deleteModele() {
            this.$vs.loading();
            notificationService.deleteModele(this.id).then(response => {
                console.log(response);
                this.$swal.fire({
                    position: "absolute",
                    icon: "success",
                    title: "Suppression modèle notification faite avec succès",
                    showConfirmButton: true,
                    timer: 2500
                });
                this.loadData();
            }).catch(error => {
                this.dataListModele = [];
                this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error
                });
            })
        },
        reset_data() {
            this.selectedModele = {};
            this.selectedsClient = [];
        },
        notifier() {
            this.$vs.loading();
            var clients = this.selectedsClient.map(function (item) {
                return item['No'];
            });
            const notificationData = {
                modele: this.selectedModele.id,
                clients: clients
            }
            notificationService.AddNotification(notificationData).then(response => {
                console.log(response)
                this.selectedModele = {};
                this.selectedsClient = [];
                this.$swal.fire({
                    position: "absolute",
                    icon: "success",
                    title: "Notification a été partagé avec succès",
                    showConfirmButton: true,
                    timer: 2500
                });
                this.$vs.loading.close();
            }).catch(error => {
                this.$vs.loading.close();
                this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error
                });
            })
        },
        loadData() {
            try {
                notificationService.getAllModele().then(response => {
                    this.dataListModele = response.data
                    this.dataListClient = JSON.parse(JSON.stringify(this.$store.state.article.clients.value)).filter(function (e) {
                        return e.Portal_Status == 'Actif'
                    });
                });
            } catch {
                this.dataListModele = [];
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        },
        OpenModal(mode, tr) {
            if (mode == "créer") {
                this.modeleNotification = {};
                this.id = 0;
                this.popupActiv = true;
                this.popupDisabled = false;
            } else if (mode == "modifier") {
                this.id = tr.id;
                this.popupDisabled = false;
                this.modeleNotification.designation = tr.designation;
                this.modeleNotification.description = tr.description;
                this.modeleNotification.title = tr.title;
                this.modeleNotification.msg = tr.msg;
                this.modeleNotification.icon = tr.icon;
                this.color = tr.color;
                this.popupActiv = true;
            } else if (mode == "consulter") {
                this.popupDisabled = true;
                this.modeleNotification.designation = tr.designation;
                this.modeleNotification.description = tr.description;
                this.modeleNotification.title = tr.title;
                this.modeleNotification.msg = tr.msg;
                this.modeleNotification.icon = tr.icon;
                this.color = tr.color;
                this.popupActiv = true;
            }
        },
        enregistrer() {
            this.$vs.loading();
            const modeleNotificationData = {
                id: this.id,
                designation: this.modeleNotification.designation,
                description: this.modeleNotification.description,
                title: this.modeleNotification.title,
                msg: this.modeleNotification.msg,
                color: this.color,
                icon: this.modeleNotification.icon,
            }
            try {
                notificationService.AddModele(modeleNotificationData).then(response => {
                    console.log(response)
                    this.modeleNotification = {
                            designation: "",
                            description: "",
                            title: "",
                            msg: "",
                            icon: "",
                        },
                        this.color = "#28C76F"
                    this.loadData();
                    this.popupActiv = false;
                    this.$swal.fire({
                        position: "absolute",
                        icon: "success",
                        title: "Modèle notification enregistré avec succès",
                        showConfirmButton: true,
                        timer: 2500
                    });
                }).catch(error => {
                    console.log(error)
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 10000,
                        title: "Erreur s'est produite l'ors de la validation",
                        text: error.data,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                })
            } catch {
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la validation",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        }
    },
    computed: {
        DisableConfirmer() {
            if (this.selectedModele.id != undefined && this.selectedsClient.length != 0)
                return false;
            else
                return true;
        },
        DisableEnregistrer() {
            var disabled = false;
            if (this.popupDisabled)
                disabled = true;
            else {
                // console.log(this.modeleNotification)
                // if (this.modeleNotification.designation == "")
                //     disabled = true;
                // if (this.modeleNotification.description == "")
                //     disabled = true;
                // if (this.modeleNotification.title == "")
                //     disabled = true;
                // if (this.modeleNotification.msg == "")
                //     disabled = true;
                // if (this.modeleNotification.icon == "")
                //     disabled = true;
                disabled = false;
            }
            return disabled;
        }
    },
    created() {
        if (this.$store.state.AppActiveUser.id != '' && this.$store.state.article.clients.value != null) {
            this.loadData();
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "article/UPDATE_CLIENT") {
                    this.loadData();
                }
            });
        }
    },
    mounted() {
        this.isMounted = true;
        this.$vs.loading({
            background: this.backgroundLoading,
            // color: this.colorLoading,
            type: 'radius',
            container: "#notification-nouveau",
            scale: 0.45,
            clickEffect: true
        });
    }
}
</script>

<style lang="scss">
#notification-nouveau {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
